module.exports = __webpack_public_path__ + "static/media/plus.531eb8cf.svg";